module.exports = __webpack_public_path__ + "img/Group 1046three.01c1583a.png";